import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ConfirmRegisterWaitlistModalProps {
  isOpen: boolean;
  onClose: () => void;
  userFullName: string;
  onConfirm: (sendNotification: boolean) => Promise<void>;
}

function ConfirmRegisterWaitlistModal({
  isOpen,
  onClose,
  userFullName,
  onConfirm,
}: ConfirmRegisterWaitlistModalProps) {
  const [isWorking, setIsWorking] = useState(false);
  const [sendNotification, setSendNotification] = useState(true);

  const handleConfirm = async () => {
    setIsWorking(true);
    try {
      await onConfirm(sendNotification);
      onClose();
    } catch (error) {
      console.error("Failed to register from waitlist:", error);
    } finally {
      setIsWorking(false);
    }
  };

  return (
    <Dialog onOpenChange={(open) => !open && onClose()} open={isOpen}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Register from Waitlist</DialogTitle>
          <DialogDescription className="text-gray-600 dark:text-gray-400">
            Are you sure you want to register <strong>{userFullName}</strong>{" "}
            from the waitlist?
          </DialogDescription>
        </DialogHeader>

        <label className="flex items-center gap-2 cursor-pointer">
          <input
            checked={sendNotification}
            className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            onChange={(e) => setSendNotification(e.target.checked)}
            type="checkbox"
          />
          <span className="text-sm text-gray-700 dark:text-gray-300">
            Send notification to the user
          </span>
        </label>

        <DialogFooter>
          <Button disabled={isWorking} onClick={onClose} variant="outline">
            Cancel
          </Button>
          <Button disabled={isWorking} onClick={handleConfirm}>
            {isWorking ? "Registering..." : "Register"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ConfirmRegisterWaitlistModal;
